import { ConsumersServiceInterface, Consumer, SingleResponse, APIClientInterface, ValidateConsumerUploadResponse, ConsumerUploadRecord } from '../types'

export default class ConsumersService implements ConsumersServiceInterface {
	constructor(private client: APIClientInterface) {}

	get(customerId: number, serial: string): Promise<SingleResponse<Consumer[]>> {
		return this.client.get(`/endcustomers/${customerId}/licenses/${serial}/consumers`)
	}

	add(customerId: number, serial: string, username: string): Promise<SingleResponse<Consumer>> {
		return this.client.post(`/endcustomers/${customerId}/licenses/${serial}/consumers`, JSON.stringify({ username }))
	}

	remove(customerId: number, serial: string, username: string): Promise<void> {
		return this.client.delete(`/endcustomers/${customerId}/licenses/${serial}/consumers/${username}`)
	}

	validate(customerId: number, serial: string, data: File): Promise<ValidateConsumerUploadResponse> {
		return this.client.postFile(`/endcustomers/${customerId}/licenses/${serial}/consumers/validate`, data)
	}

	upload(customerId: number, serial: string, users: ConsumerUploadRecord[]): Promise<void> {
		return this.client.post(`/endcustomers/${customerId}/licenses/${serial}/consumers/upload`, JSON.stringify({ users }))
	}
}
